import urlJoin from 'url-join';
import { connectedStore } from '../../store';
import config from '../../config';

const composeWsAssetUrl = (path) => {
  const store = connectedStore.get();
  const state = store.getState();
  const apiUrl = config.selectors.getServiceAPIUrl(state);
  return urlJoin(apiUrl, 'cdn', path);
};

export default composeWsAssetUrl;
